import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Utilities } from '../../../utils/utilities';

@Component({
    selector: 'bdo-poll-done',
    templateUrl: './poll-done.component.html',
    styleUrls: ['./poll-done.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollDoneComponent {

}
